<div id="carousel3" class="carousel slide carousel-fade carouselTipo2" data-bs-ride="carousel">
    <div class="carousel-inner">

        
         <div class="carousel-item" 
                *ngFor="let item of oneColCarousel_items; index as i"
                [ngClass]="{'active': item.active}"       
         >
              <img src="https://{{item.imgSrc}}" class="d-block img-full-cover" alt="{{item.imgAlt}}">
        </div>


    </div>
     <div class="controls bg-dark">
             <div class="controls-blq">
                    <button class="carousel-control-prev" type="button" data-bs-target="#carousel3" data-bs-slide="prev">
                      <span class="carousel-control-prev-icon prueba" aria-hidden="true"></span>
                      <span class="visually-hidden">Previo</span>
                    </button>
                   <button class="carousel-control-next" type="button" data-bs-target="#carousel3" data-bs-slide="next">
                      <span class="carousel-control-next-icon prueba" aria-hidden="true"></span>
                      <span class="visually-hidden">Siguiente</span>
                   </button>
            </div>       
      </div>
</div><!-- fin carousel-->
